export default __webpack_public_path__ + "static/media/multi-system-nodes.bca49901.svg";